import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'

import {PageStore} from '@/src/infrastructure/store/page-store'

import {PageStoreFactory} from '@/src/ports/store/page-store-factory'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<PageStoreFactory>(DI.PageStoreFactory).toFactory(() => (data, queryKey) => new PageStore(data, queryKey))
}

export const AppModule = new ContainerModule(initializeModule)
